import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "text-center scenario-title" }
const _hoisted_4 = { class: "text-success" }
const _hoisted_5 = { class: "col-12 mb-4" }
const _hoisted_6 = { class: "button-navigation" }
const _hoisted_7 = {
  key: 6,
  type: "submit",
  class: "btn btn-secondary disabled"
}
const _hoisted_8 = {
  key: 8,
  type: "submit",
  class: "btn btn-secondary",
  disabled: ""
}
const _hoisted_9 = {
  key: 1,
  class: "row g-0"
}
const _hoisted_10 = {
  key: 2,
  id: "scenario-authoring"
}
const _hoisted_11 = { class: "row g-0" }
const _hoisted_12 = { class: "col-md-9 px-0" }
const _hoisted_13 = { class: "mx-4" }
const _hoisted_14 = {
  key: 0,
  class: "col-md-3 mt-3 px-0"
}
const _hoisted_15 = { class: "card-body mb-2 px-4" }
const _hoisted_16 = { class: "list-group list-group-flush mb-4" }
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center mt-4" }
const _hoisted_18 = { href: "javascript:void(0)" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-4"
}
const _hoisted_20 = { href: "javascript:void(0)" }
const _hoisted_21 = { class: "d-flex justify-content-between align-items-center mt-4" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scenario_field = _resolveComponent("scenario-field")!
  const _component_scenario_dynamic_field = _resolveComponent("scenario-dynamic-field")!
  const _component_scenario_field_group = _resolveComponent("scenario-field-group")!
  const _component_masonry_wall = _resolveComponent("masonry-wall")!
  const _component_tab = _resolveComponent("tab")!
  const _component_observer_scorecard = _resolveComponent("observer-scorecard")!
  const _component_standardized_patient_scorecard = _resolveComponent("standardized-patient-scorecard")!
  const _component_scenario_participant_feedback = _resolveComponent("scenario-participant-feedback")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_scenario_notes = _resolveComponent("scenario-notes")!
  const _component_scenario_select_trainer = _resolveComponent("scenario-select-trainer")!
  const _component_scenario_partner_distribution = _resolveComponent("scenario-partner-distribution")!
  const _component_scenario_user_assignment = _resolveComponent("scenario-user-assignment")!
  const _component_scorecard_display_settings = _resolveComponent("scorecard-display-settings")!
  const _component_scenario_fee_settings = _resolveComponent("scenario-fee-settings")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.loading_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.scenario)
            ? (_openBlock(), _createElementBlock("div", {
                class: "row g-0",
                key: _ctx.scenario?.data.status
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.scenario?.data.title) + " ", 1),
                    _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.ScenarioStatus[_ctx.scenario?.data?.status]) + ")", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (((_ctx.scenario?.data.status === _ctx.ScenarioStatus.DRAFT || _ctx.scenario?.data.status === _ctx.ScenarioStatus.EDITING) && !_ctx.userIsReviewer))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.review && _ctx.review(...args))),
                          class: "btn btn-primary"
                        }, "Submit For Review"))
                      : _createCommentVNode("", true),
                    ((_ctx.scenario?.data.status === _ctx.ScenarioStatus.REVIEW) && (_ctx.userIsReviewer || _ctx.store.getters.hasPermission('scenario.admin')))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "submit",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editing && _ctx.editing(...args))),
                          class: "btn btn-primary"
                        }, "Send Back for Editing"))
                      : _createCommentVNode("", true),
                    ((_ctx.scenario?.data.status === _ctx.ScenarioStatus.REVIEW) && (_ctx.userIsReviewer || _ctx.store.getters.hasPermission('scenario.admin')))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "submit",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args))),
                          class: "btn btn-primary"
                        }, "Approve"))
                      : _createCommentVNode("", true),
                    (_ctx.canTake)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          type: "submit",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.take && _ctx.take(...args))),
                          class: "btn btn-primary"
                        }, "Take Scenario Under My Review"))
                      : _createCommentVNode("", true),
                    ((_ctx.scenario?.data.status === _ctx.ScenarioStatus.APPROVED && (_ctx.isHeadTrainer || _ctx.store.getters.hasPermission('scenario.admin'))))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          type: "submit",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.publish && _ctx.publish(...args))),
                          class: "btn btn-primary"
                        }, "Go Live with this Scenario"))
                      : _createCommentVNode("", true),
                    (((_ctx.scenario?.data.status === _ctx.ScenarioStatus.APPROVED || _ctx.scenario?.data.status === _ctx.ScenarioStatus.PUBLISHED) && _ctx.store.getters.user.props?.super_admin && !_ctx.makeLiveEdits && _ctx.selectedTab == 'Scenario'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          type: "submit",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.adminEdits && _ctx.adminEdits(...args))),
                          class: "btn btn-primary"
                        }, "Make Scenario Changes"))
                      : (((_ctx.scenario?.data.status === _ctx.ScenarioStatus.APPROVED || _ctx.scenario?.data.status === _ctx.ScenarioStatus.PUBLISHED) && _ctx.store.getters.user.props?.super_admin && !_ctx.makeLiveEdits && _ctx.selectedTab != 'Scenario'))
                        ? (_openBlock(), _createElementBlock("button", _hoisted_7, "Make Scenario Changes"))
                        : _createCommentVNode("", true),
                    (((_ctx.scenario?.data.status === _ctx.ScenarioStatus.APPROVED || _ctx.scenario?.data.status === _ctx.ScenarioStatus.PUBLISHED) && _ctx.store.getters.user.props?.super_admin && _ctx.makeLiveEdits && _ctx.selectedTab == 'Scenario'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 7,
                          type: "submit",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.adminEditsDone && _ctx.adminEditsDone(...args))),
                          class: "btn btn-primary"
                        }, "Done with Changes"))
                      : (((_ctx.scenario?.data.status === _ctx.ScenarioStatus.APPROVED || _ctx.scenario?.data.status === _ctx.ScenarioStatus.PUBLISHED) && _ctx.store.getters.user.props?.super_admin && _ctx.makeLiveEdits && _ctx.selectedTab != 'Scenario'))
                        ? (_openBlock(), _createElementBlock("button", _hoisted_8, "Done with Changes"))
                        : _createCommentVNode("", true),
                    (_ctx.store.getters.hasPermission('scenario.clone'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 9,
                          type: "submit",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cloneScenario && _ctx.cloneScenario(...args))),
                          class: "btn btn-primary"
                        }, "Clone Scenario"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[25] || (_cache[25] = [
                _createStaticVNode("<div class=\"col-12\"><div class=\"text-center scenario-title\"> You do not have permission to access this scenario <span class=\"text-success\">(No Access)</span></div><div class=\"text-center\"><a href=\"/#/dashboard\">Return to My Dashboard &gt;&gt;</a></div></div>", 1)
              ]))),
          (_ctx.scenario)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_tabs, {
                      options: { useUrlFragment: false },
                      "nav-class": "nav nav-pills m-3",
                      "nav-item-class": "nav-item col-md-6 col-sm-12 text-center mb-4",
                      "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
                      "nav-item-link-active-class": "active",
                      onChanged: _ctx.tabChanged
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_tab, {
                          prefix: "<h2 class='mt-2 scenario-tabs'>",
                          name: "Scenario"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_masonry_wall, {
                                items: _ctx.fields,
                                "ssr-columns": 2,
                                gap: 15,
                                "origin-top": false
                              }, {
                                default: _withCtx(({ item, index }) => [
                                  (_openBlock(), _createBlock(_component_scenario_field_group, {
                                    onClick: ($event: any) => (_ctx.selectedField = _ctx.toSnakeCase(item.label)),
                                    label: item.label,
                                    description: item.description,
                                    selected: _ctx.toSnakeCase(item.label) === _ctx.selectedField ,
                                    key: index,
                                    "enable-comments": _ctx.enableComments,
                                    "show-comment-bubble": _ctx.showCommnetBubble,
                                    scenario: _ctx.scenario
                                  }, _createSlots({
                                    default: _withCtx(() => [
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 0,
                                            type: "image-select",
                                            modelValue: _ctx.scenario.data.patient_image.location,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scenario.data.patient_image.location) = $event)),
                                            field: "patient_image",
                                            required: true,
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true),
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 1,
                                            type: "text",
                                            modelValue: _ctx.scenario.data.title,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scenario.data.title) = $event)),
                                            field: "title",
                                            required: true,
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true),
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 2,
                                            type: "text",
                                            modelValue: _ctx.scenario.data.patient_name,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.scenario.data.patient_name) = $event)),
                                            field: "patient_name",
                                            required: true,
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true),
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 3,
                                            type: "radio",
                                            modelValue: _ctx.scenario.data.televisit,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.scenario.data.televisit) = $event)),
                                            field: "televisit",
                                            required: false,
                                            items: [{'label':'Yes', 'value':true},{'label':'No', 'value':false}],
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true),
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 4,
                                            type: "editor",
                                            modelValue: _ctx.scenario.data.objective,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.scenario.data.objective) = $event)),
                                            field: "objective",
                                            required: true,
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true),
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 5,
                                            type: "text",
                                            modelValue: _ctx.scenario.data.target_audience,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.scenario.data.target_audience) = $event)),
                                            field: "target_audience",
                                            required: true,
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true),
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 6,
                                            type: "text",
                                            modelValue: _ctx.scenario.data.summary,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.scenario.data.summary) = $event)),
                                            field: "summary",
                                            required: true,
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true),
                                      (item.label == 'Overview')
                                        ? (_openBlock(), _createBlock(_component_scenario_field, {
                                            key: 7,
                                            type: "select",
                                            modelValue: _ctx.scenario.data.session_duration,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.scenario.data.session_duration) = $event)),
                                            field: "session_duration",
                                            required: true,
                                            items: [{'label':'30 mins','value':30},{'label':'60 mins','value':60}],
                                            "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits,
                                            onSave: _ctx.fieldUpdate
                                          }, null, 8, ["modelValue", "can-edit", "onSave"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, [
                                    (item.label != 'Overview')
                                      ? {
                                          name: "default",
                                          fn: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fields, (field, findex) => {
                                              return (_openBlock(), _createBlock(_component_scenario_dynamic_field, {
                                                "disable-label": item.fields.length === 1,
                                                key: findex,
                                                scenario: _ctx.scenario,
                                                field: field,
                                                "can-edit": (_ctx.userIsAuthor && _ctx.enableForm) || _ctx.makeLiveEdits
                                              }, null, 8, ["disable-label", "scenario", "field", "can-edit"]))
                                            }), 128))
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1032, ["onClick", "label", "description", "selected", "enable-comments", "show-comment-bubble", "scenario"]))
                                ]),
                                _: 1
                              }, 8, ["items"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_tab, {
                          prefix: "<h2 class='mt-2 scenario-tabs'>",
                          name: "Observer Scorecard"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "m-4",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectedField = 'observer_scorecard'))
                            }, [
                              _createVNode(_component_observer_scorecard, {
                                scenario: _ctx.scenario,
                                field: "observer_scorecard",
                                label: "Observer Scorecard",
                                "enable-comments": _ctx.enableComments,
                                "show-comment-bubble": _ctx.showCommnetBubble
                              }, null, 8, ["scenario", "enable-comments", "show-comment-bubble"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_tab, {
                          prefix: "<h2 class='mt-2 scenario-tabs'>",
                          name: "SP Scorecard"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "m-4",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.selectedField = 'sp_scorecard'))
                            }, [
                              _createVNode(_component_standardized_patient_scorecard, {
                                scenario: _ctx.scenario,
                                field: "sp_scorecard",
                                label: "SP Scorecard",
                                "enable-comments": _ctx.enableComments,
                                "show-comment-bubble": _ctx.showCommnetBubble
                              }, null, 8, ["scenario", "enable-comments", "show-comment-bubble"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_tab, {
                          prefix: "<h2 class='mt-2 scenario-tabs'>",
                          name: "Participant Feedback"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "m-4",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectedField = 'participant_feedback'))
                            }, [
                              _createVNode(_component_scenario_participant_feedback, {
                                scenario: _ctx.scenario,
                                field: "participant_feedback",
                                label: "Participant Feedback",
                                "enable-comments": _ctx.enableComments,
                                "show-comment-bubble": _ctx.showCommnetBubble
                              }, null, 8, ["scenario", "enable-comments", "show-comment-bubble"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onChanged"])
                  ]),
                  (_ctx.scenario?.data.status !== _ctx.ScenarioStatus.DRAFT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_ctx.scenario?.data.status === _ctx.ScenarioStatus.DRAFT || _ctx.scenario?.data.status === _ctx.ScenarioStatus.REVIEW || _ctx.scenario?.data.status === _ctx.ScenarioStatus.EDITING)
                          ? (_openBlock(), _createBlock(_component_scenario_notes, {
                              key: 0,
                              "static-view": "",
                              scenario: _ctx.scenario,
                              field: _ctx.selectedField,
                              "enable-commenting": _ctx.enableComments
                            }, null, 8, ["scenario", "field", "enable-commenting"]))
                          : (_openBlock(), _createBlock(_component_tabs, {
                              key: 1,
                              options: { useUrlFragment: false },
                              "nav-class": "nav nav-pills scenario-settings",
                              "nav-item-class": "nav-item text-center",
                              "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
                              "nav-item-link-active-class": "active"
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.isTrainer)
                                  ? (_openBlock(), _createBlock(_component_tab, {
                                      key: 0,
                                      name: "Details"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "scenario-field-header with-elements bg-secondary text-white" }, " Details ", -1)),
                                        _createElementVNode("div", _hoisted_15, [
                                          _createElementVNode("ul", _hoisted_16, [
                                            _createElementVNode("li", _hoisted_17, [
                                              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-muted" }, "Created By:", -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.scenario?.data.author.name), 1)
                                              ])
                                            ]),
                                            (_ctx.scenario?.data.reviewer !== null)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-muted" }, "Reviewed By:", -1)),
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.scenario?.data.reviewer.name), 1)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_scenario_field, {
                                              type: "editor",
                                              modelValue: _ctx.scenario.data.funding_text,
                                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.scenario.data.funding_text) = $event)),
                                              field: "funding_text",
                                              "can-edit": _ctx.canConfig,
                                              "list-group-item": "",
                                              onSave: _ctx.fieldUpdate
                                            }, null, 8, ["modelValue", "can-edit", "onSave"]),
                                            _createVNode(_component_scenario_field, {
                                              type: "select",
                                              modelValue: _ctx.scenario.data.accreditation_Id,
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.scenario.data.accreditation_Id) = $event)),
                                              field: "accreditation_Id",
                                              label_override: "Accreditation",
                                              items: [{'label':'No Accreditation', 'value':''}],
                                              "can-edit": _ctx.canConfig,
                                              "list-group-item": "",
                                              onSave: _ctx.fieldUpdate
                                            }, null, 8, ["modelValue", "can-edit", "onSave"]),
                                            _createVNode(_component_scenario_field, {
                                              type: "money",
                                              modelValue: _ctx.scenario.data.giftcard_amount,
                                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.scenario.data.giftcard_amount) = $event)),
                                              field: "giftcard_amount",
                                              "can-edit": _ctx.canConfig,
                                              "list-group-item": "",
                                              onSave: _ctx.fieldUpdate
                                            }, null, 8, ["modelValue", "can-edit", "onSave"]),
                                            _createVNode(_component_scenario_field, {
                                              type: "select",
                                              modelValue: _ctx.scenario.data.giftcard_campaign_id,
                                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.scenario.data.giftcard_campaign_id) = $event)),
                                              field: "giftcard_campaign_id",
                                              label_override: "Giftcard Campaign",
                                              items: _ctx.giftcard_options,
                                              "can-edit": _ctx.canConfig,
                                              "list-group-item": "",
                                              onSave: _ctx.fieldUpdate
                                            }, null, 8, ["modelValue", "items", "can-edit", "onSave"]),
                                            _createVNode(_component_scenario_field, {
                                              type: "select",
                                              modelValue: _ctx.scenario.data.enable_giftcard,
                                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.scenario.data.enable_giftcard) = $event)),
                                              field: "enable_giftcard",
                                              label_override: "Enable Giftcards",
                                              items: [{'label':'Yes', 'value':1},{'label':'No', 'value':0}],
                                              "can-edit": _ctx.canConfig,
                                              "list-group-item": "",
                                              onSave: _ctx.fieldUpdate
                                            }, null, 8, ["modelValue", "can-edit", "onSave"]),
                                            _createVNode(_component_scenario_field, {
                                              type: "tags",
                                              modelValue: _ctx.scenario.data.tags,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.scenario.data.tags) = $event)),
                                              field: "tags",
                                              items: _ctx.tags,
                                              "can-edit": _ctx.canConfig,
                                              "list-group-item": "",
                                              onSave: _ctx.fieldUpdate
                                            }, null, 8, ["modelValue", "items", "can-edit", "onSave"]),
                                            _createElementVNode("li", _hoisted_21, [
                                              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-muted" }, "Created On:", -1)),
                                              _createElementVNode("div", null, _toDisplayString(_ctx.moment(_ctx.scenario?.data.created_at).format('M/D/Y')), 1)
                                            ]),
                                            _createElementVNode("li", _hoisted_22, [
                                              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-muted" }, "Last Update:", -1)),
                                              _createElementVNode("div", null, _toDisplayString(_ctx.moment(_ctx.scenario?.data.updated_at).format('M/D/Y')), 1)
                                            ])
                                          ])
                                        ]),
                                        (_ctx.scenario)
                                          ? (_openBlock(), _createBlock(_component_scenario_select_trainer, {
                                              key: 0,
                                              "can-edit": _ctx.canConfig,
                                              scenario: _ctx.scenario
                                            }, null, 8, ["can-edit", "scenario"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!_ctx.isTrainer && !_ctx.isHeadTrainer)
                                  ? (_openBlock(), _createBlock(_component_tab, {
                                      key: 1,
                                      name: "Comments"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_scenario_notes, {
                                          "class-style": "card-body",
                                          "static-view": "",
                                          scenario: _ctx.scenario,
                                          field: _ctx.selectedField,
                                          "enable-commenting": _ctx.enableComments
                                        }, null, 8, ["scenario", "field", "enable-commenting"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!_ctx.isTrainer && !_ctx.isHeadTrainer)
                                  ? (_openBlock(), _createBlock(_component_tab, {
                                      key: 2,
                                      name: "Distribution"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.scenario)
                                          ? (_openBlock(), _createBlock(_component_scenario_partner_distribution, {
                                              key: 0,
                                              "can-edit": _ctx.canConfig,
                                              scenario: _ctx.scenario
                                            }, null, 8, ["can-edit", "scenario"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_tab, { name: "SP" }, {
                                  default: _withCtx(() => [
                                    (_ctx.scenario)
                                      ? (_openBlock(), _createBlock(_component_scenario_user_assignment, {
                                          key: 0,
                                          "can-edit": _ctx.canConfig,
                                          scenario: _ctx.scenario
                                        }, null, 8, ["can-edit", "scenario"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_tab, { name: "Observers" }, {
                                  default: _withCtx(() => [
                                    (_ctx.scenario)
                                      ? (_openBlock(), _createBlock(_component_scenario_user_assignment, {
                                          key: 0,
                                          "can-edit": _ctx.canConfig,
                                          scenario: _ctx.scenario,
                                          observer: ""
                                        }, null, 8, ["can-edit", "scenario"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.isTrainer)
                                  ? (_openBlock(), _createBlock(_component_tab, {
                                      key: 3,
                                      name: "Scorecard Display"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.scenario)
                                          ? (_openBlock(), _createBlock(_component_scorecard_display_settings, {
                                              key: 0,
                                              "can-edit": _ctx.canConfig,
                                              scenario: _ctx.scenario
                                            }, null, 8, ["can-edit", "scenario"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!_ctx.isTrainer)
                                  ? (_openBlock(), _createBlock(_component_tab, {
                                      key: 4,
                                      name: "Fee"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.scenario)
                                          ? (_openBlock(), _createBlock(_component_scenario_fee_settings, {
                                              key: 0,
                                              "can-edit": _ctx.canConfig,
                                              scenario: _ctx.scenario
                                            }, null, 8, ["can-edit", "scenario"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.loading_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _cache[31] || (_cache[31] = _createElementVNode("h3", null, "Error Loading Scenario", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loading_error_str), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}